import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card1, Card2, Card3, CardQR } from "../components";
import { ToastContainer, toast } from "react-toastify";
import { getCardBySlug, urlHome } from "../constants";
import ModalAddContactFromCard from "../components/modals/ModalAddContactFromCard";
import ModalInterestedForm from "../components/modals/ModalInterestedForm";

const Card = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const [data, setData] = useState(null);
  const [isCard, setIsCard] = useState(true);
  const navigate = useNavigate();
  const { slug } = useParams();
  useEffect(() => {
    getCardBySlug(slug, setData, navigate);
  }, []);

  const addContact = () => {
    const element = document.createElement("a");
    const file = new Blob([data.vcard], { type: "text/x-vcard;charset=utf-8" });
    element.href = URL.createObjectURL(file);
    element.text = "Add to Contact";
    element.download = data.first_name + " " + data.last_name + ".vcf";
    document.body.appendChild(element);
    element.click();
    if (user) {
      document.getElementById("add_contact_modal").showModal();
    } else {
      document.getElementById("register_modal").showModal();
    }
  };
  return (
    <div className="flex flex-col h-[100vh] w-full justify-start items-center relative">
      <div
        className="flex flex-row rounded-l-full rounded-r-full mt-5 p-1 bg-primary"
        style={{
          "box-shadow":
            "rgb(50, 50, 50) 2px 2px 4px 0px inset, rgba(200, 200, 200, 0.5) -3px -3px 6px 1px inset",
        }}
      >
        <div
          className={`p-2 rounded-l-full rounded-r-full w-[70px] cursor-pointer text-center ${
            isCard
              ? "backdrop-blur-sm bg-white bg-opacity-20 text-white font-semibold shadow-xl"
              : "text-white"
          }`}
          onClick={(_) => setIsCard(true)}
        >
          Card
        </div>
        <div
          className={`p-2 rounded-l-full rounded-r-full w-[70px] cursor-pointer text-center ${
            !isCard
              ? "backdrop-blur-sm bg-white bg-opacity-20 text-white font-semibold shadow-xl"
              : "text-white"
          }`}
          onClick={(_) => setIsCard(false)}
        >
          QR
        </div>
      </div>

      <div className="flex flex-col w-[90%] max-w-[400px] justify-start items-center pt-5 group [perspective:1000px]">
        <div
          className={`relative w-full transition-all duration-500 [transform-style:preserve-3d] ${
            isCard ? "" : "[transform:rotateY(180deg)]"
          }`}
          id="cardContainer"
        >
          <div
            className={`absolute inset-0 [backface-visibility:hidden] ${
              isCard ? "pointer-events-auto" : "pointer-events-none"
            }`}
          >
            {data == null ? (
              "Loading..."
            ) : data.card_template_label == "straight" ? (
              <Card1
                colorFirst={"#" + data.color_theme_value.split(",")[0]}
                colorSecond={"#" + data.color_theme_value.split(",")[1]}
                imageSourceHeader={data.header_image_url}
                imageSourceLogo={data.logo_image_url}
                imageSourceProfile={data.profile_image_url}
                prefix={data.prefix}
                suffix={data.suffix}
                firstName={data.first_name}
                middleName={data.middle_name}
                lastName={data.last_name}
                jobTitle={data.job_title}
                company={data.company}
                aboutMe={data.about_me}
                informations={data.card_social.map((val, ind) => ({
                  ...val,
                  value: val.input_value,
                  image_url: val.icon_image_url,
                }))}
                maximize={true}
                vcard={addContact}
                isBadge={data.is_badge}
              />
            ) : data.card_template_label == "oval" ? (
              <Card2
                colorFirst={"#" + data.color_theme_value.split(",")[0]}
                colorSecond={"#" + data.color_theme_value.split(",")[1]}
                imageSourceHeader={data.header_image_url}
                imageSourceLogo={data.logo_image_url}
                imageSourceProfile={data.profile_image_url}
                prefix={data.prefix}
                suffix={data.suffix}
                firstName={data.first_name}
                middleName={data.middle_name}
                lastName={data.last_name}
                jobTitle={data.job_title}
                company={data.company}
                aboutMe={data.about_me}
                informations={data.card_social.map((val, ind) => ({
                  ...val,
                  value: val.input_value,
                  image_url: val.icon_image_url,
                }))}
                maximize={true}
                vcard={addContact}
                isBadge={data.is_badge}
              />
            ) : (
              <Card3
                colorFirst={"#" + data.color_theme_value.split(",")[0]}
                colorSecond={"#" + data.color_theme_value.split(",")[1]}
                imageSourceHeader={data.header_image_url}
                imageSourceLogo={data.logo_image_url}
                imageSourceProfile={data.profile_image_url}
                prefix={data.prefix}
                suffix={data.suffix}
                firstName={data.first_name}
                middleName={data.middle_name}
                lastName={data.last_name}
                jobTitle={data.job_title}
                company={data.company}
                aboutMe={data.about_me}
                informations={data.card_social.map((val, ind) => ({
                  ...val,
                  value: val.input_value,
                  image_url: val.icon_image_url,
                }))}
                maximize={true}
                vcard={addContact}
                isBadge={data.is_badge}
              />
            )}
          </div>
          {data == null ? (
            "Loading..."
          ) : (
            <div
              className={`flex flex-col w-full justify-start items-center h-fit absolute inset-0 [transform:rotateY(180deg)] [backface-visibility:hidden] ${
                isCard ? "pointer-events-none" : "pointer-events-auto"
              }`}
            >
              <CardQR
                colorFirst={"#" + data.color_theme_value.split(",")[0]}
                colorSecond={"#" + data.color_theme_value.split(",")[1]}
                imageSourceProfile={data.profile_image_url}
                maximize={true}
                prefix={data.prefix}
                suffix={data.suffix}
                firstName={data.first_name}
                middleName={data.middle_name}
                lastName={data.last_name}
                jobTitle={data.job_title}
                company={data.company}
                aboutMe={data.about_me}
                slug={slug}
              />
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-0 text-center bg-primary py-1 text-white rounded-t-xl text-[11px] w-[90%] max-w-[400px]">
        Build by{" "}
        <a href={urlHome} className="underline">
          Nitomeyo
        </a>
      </div>
      {data && user ? (
        <ModalAddContactFromCard user={user} cardId={data.card_id} />
      ) : (
        <ModalInterestedForm />
      )}
    </div>
  );
};

export default Card;
